import React from "react"

export default function TeamBuilding() {

    return (
        <div className="team-building-container">
            <h1 style={{marginTop: "1em", marginBottom: "1em", fontSize: "4rem"}}>Ускоро у понуди!</h1>
        </div>
    )
}